export const ROTA_RELATORIO_SUGESTOES = "/admin/impulsione/relatorio-ofertas/campanhas/sugestoes-inteligentes";
